import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import DocumentHead from 'legacyComponents/documentHead';
import { withNamespaces, Trans, WithNamespaces } from 'react-i18next';

import { Link } from 'core/routing';
import { HeaderMarginTop as Main, Center } from 'legacyComponents/styled/lib';
import Header from 'apps/components/header/header';

import { Button } from 'components';
import { Message, Code, Wrapper, ButtonStyled } from './FourOhFour.styled';

interface FourOhFourProps extends WithNamespaces {
  subPage: ReactNode;
  canBePrivate: boolean;
  type: string;
}

export const FourOhFour = withNamespaces()(
  observer((props: FourOhFourProps) => {
    const { t, subPage, canBePrivate } = props;

    let privateCTA;
    if (canBePrivate) {
      privateCTA = (
        <>
          <Message small>
            <Trans>Perhaps it&apos;s a private {props.type || 'Page'}?</Trans>
          </Message>
          <Center>
            <Link name='home.signIn'>
              <Button outline text={t('Log in / Sign up')} />
            </Link>
          </Center>
        </>
      );
    }

    return (
      <div>
        <DocumentHead title={`404 - ${t('Not Found')}`} index='noindex' />
        {subPage ? (
          <>
            <Code subPage>404</Code>
            <Message>
              <Trans>
                Woops! We can&apos;t find the {props.type || 'Page'} you&apos;re
                looking for...
              </Trans>
            </Message>
            {privateCTA}
          </>
        ) : (
          <>
            <Header />
            <Main>
              <Wrapper>
                <Code>404</Code>
                <Message>
                  <Trans>
                    Woops! We can&apos;t find the {props.type || 'Page'}{' '}
                    you&apos;re looking for...
                  </Trans>
                </Message>
                <Center>
                  <Link name='home'>
                    <ButtonStyled outline text={t('Back Home')} />
                  </Link>
                </Center>
              </Wrapper>
            </Main>
          </>
        )}
      </div>
    );
  }),
);
